import { createApp } from './index';

const { app, router } = createApp();

router.onReady(() => {
  app.$mount('#app');
});
